import React from "react";
import type { PricePromotionType } from "../../../../../../../common-deprecated/types/CommonTypes";
import * as Styles from "./styles/PricePromoIcon";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/lexus/Popover";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { showMobileBasket } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import { combineSpotlightPromoDescription } from "../../../../utils/typedUtils";
import { useAemNavOffset } from "../../../../../../../common-deprecated/hooks";
import { scrollTargetIntoView } from "../../../../../../../common-deprecated/utils";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const PricePromoIcon = ({ promotions }: { promotions: PricePromotionType[] }): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const mobileBasketIsShown = useBnbSelector((state) => state.utils.showMobileBasket);
    const monthlyPromoIsDisabled = useBnbSelector(
        (state) => state.bnbSettings.disableMonthlyPromoIcon && state.utils.financeOption === "monthly",
    );
    const spotLightPromoInfo = combineSpotlightPromoDescription(promotions);

    const navOffset = useAemNavOffset();

    if (monthlyPromoIsDisabled) return null;

    const closeMobileBasket = (): void => {
        if (mobileBasketIsShown) {
            dispatch(showMobileBasket(false));
        }
    };
    return (
        <Styles.Wrapper>
            {promotions.map((promotion) => (
                <Styles.BadgeRounded
                    role="button"
                    key={promotion.index}
                    hasLink
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        closeMobileBasket();
                        // OR-8563: requestAnimationFrame ensures this code isn't executed until the current render cycle is completed so mobile also works.
                        window.requestAnimationFrame(() => scrollTargetIntoView(promotion.id, navOffset, false, true));
                    }}
                >
                    {promotion.index}
                </Styles.BadgeRounded>
            ))}
            {!!spotLightPromoInfo && (
                <Styles.SpotlightWrapper>
                    <Popover showOnClick content={spotLightPromoInfo} useHTML />
                </Styles.SpotlightWrapper>
            )}
        </Styles.Wrapper>
    );
};

export default PricePromoIcon;
